// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-16e95d02] {\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.pagination .turn[data-v-16e95d02] {\n    border-radius: 3px;\n    cursor: pointer;\n}\n.pagination .turn.turnTo[data-v-16e95d02] {\n      cursor: no-drop;\n}\n", ""]);
// Exports
module.exports = exports;
